import { CSSTransition } from 'react-transition-group'
import { useRef } from 'react'

import styles from './Loading.module.scss'
import classNames from 'classnames/bind'
const classes = classNames.bind(styles)

export default function Loading({ visible }) {
    const nodeRef = useRef(null)

    return (
        <CSSTransition
            mountOnEnter={true}
            unmountOnExit
            in={visible}
            timeout={300}
            classNames={{
                enter: classes('loading-animate-enter'),
                enterActive: classes('loading-animate-enter-active'),
                exit: classes('loading-animate-exit'),
                exitActive: classes('loading-animate-exit-active'),
            }}
            nodeRef={nodeRef}
        >
            <div className={classes('loading-container')} ref={nodeRef}>
                <div className={classes('lds-ring')}>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>
        </CSSTransition>
    )
}
